import React from 'react';
import { ReturnPolicy } from '../../../generated/types';
import { ReturnPolicyHyperlink } from '../../ReturnPolicyInformation';
import { ReturnPolicyCopy } from '../../ReturnPolicyInformation/ReturnPolicyCopy';

interface Props {
  shippingRestrictions: string;
  returnPolicy: ReturnPolicy | null;
}

export const ProductDetailsShippingAndReturns: React.FC<Props> = ({
  returnPolicy,
  shippingRestrictions
}) => (
  <ul className="ProductDetailsShippingAndReturns">
    {shippingRestrictions && <li>{shippingRestrictions}</li>}

    <li>
      <ReturnPolicyCopy returnPolicy={returnPolicy} />{' '}
      <ReturnPolicyHyperlink>Learn more.</ReturnPolicyHyperlink>
    </li>
  </ul>
);
